export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        prepaymentInvoiceFormIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új díjbekérő',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Letöltés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeRow'
            },
            {
                btn_text: '<i class="fas fa-share-square"></i>',
                title: 'Kiküldés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'sendProformaInvoiceDocument',
            },
            {
                btn_text: '<i class="fas fa-file-invoice-dollar"></i>',
                title: 'Előlegszámla létrehozása',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'createPrepaymentInvoice',
                additionalButtonVisible: "isProformaInvoicePaid"
            },
            {
                btn_text: '<i class="far fa-credit-card"></i>',
                title: 'Fizetettségi státusz módosítása',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'setPaidStatus',
                additionalButtonVisible: "isProformaInvoiceNotPaid"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Fizetettségi státusz visszaállítása',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'setPaidStatusBack',
                additionalButtonVisible: "isProformaInvoicePaid"
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isProformaInvoiceDeletable"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "customerName",
                label: "Név", 
                formSize:4,
                formVisible: true
            }, 
            {
                name: "isPaid",
                label: "Fizetve",
                formType: 'select', 
                formSize: 2,
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'Fizetve',
                            succesBoolean: 'true',
                        },
                        {
                            id: "2",
                            text: 'Nincs fizetve',
                            succesBoolean: 'false',
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'succesBoolean',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "fromDatePaid",
                label: "Fizetettségi dátumatól", 
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "toDatePaid",
                label: "Fizetettségi dátumig", 
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "fromDateDeadline",
                label: "Határidejétől",
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "toDateDeadline",
                label: "Határidejéig",
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "itemName",
                label: "Tárgya",
                visibility: false,
                formType: "textarea",
                formSize: 6,
                formVisible: true
            },
        ],
        selectPartnerHeaderFields: [
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "fullName",
                label: "Teljes név",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "taxNumber",
                label: "Adószám"
            },
            {
                name: "registrationNumber",
                label: "Cégjegyzékszám"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        selectPartnerRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectPartner'
            }
        ],
        selectPartnerDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        patientCompanyHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail",
                formRequired: false,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "address",
                visibility: false,
                formType: 'address',
                formVisible: true
            },
        ],
        patientFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGridFromPatientSelect'
            },
            {
                btn_text: 'Hozzáadás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveNewPatient'
            },

        ],
        customerFormActions: [
            // {
            //     btn_text: '<i class="fas fa-trash"></i> Reset',
            //     event_name: "customClick",
            //     class: "btn btn-secondary my-custom-class mx-1",
            //     event_payload: 'resetCustomerForm'
            // }
        ],
        customerHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "customerName",
                label: "Cégnév",
                sort: true,
                visibility: true,
            },
            {
                name: "customerEmail",
                label: "E-mail cím",
                visibility: true,
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: true,
            },
            {
                name: "taxablePersonText",
                label: "Adóalany",
                visibility: true,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        selectCustomerRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectCustomer'
            }
        ],
        selectCustomerDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
    }
}
